<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('API Key') }}</h4>
        </div>
      </div>
    </div>

    <creating
      v-if="creating"
      height="100%" />

    <div
      :class="{'box-loading': loading}"
      v-if="!creating"
      class="vflex-row-1 p-3">

      <div class="card mb-3">
        <div class="card-header">
          {{ $t('Current access details') }}
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2"><strong>{{ $t('Account name') }}:</strong></div>
            <div class="col-10">{{ account.name }}</div>
          </div>
          <div class="row">
            <div class="col-2"><strong>{{ $t('Account ID') }}:</strong></div>
            <div class="col-10">{{ account._id }}</div>
          </div>
          <div class="row">
            <div class="col-2"><strong>{{ $t('User') }}:</strong></div>
            <div class="col-10">{{ me.name }}</div>
          </div>
        </div>
      </div>


      <div class="form-group">
        <label>{{ $t('Token') }}</label>
        <div
          v-if="token">
          <div class="input-group" style="max-width: 450px">
            <input
              type="text"
              class="form-control"
              :value="token"
              readonly="readonly">
            <div class="input-group-append">
              <button
                class="btn btn-primary"
                @click="generateKey()">{{ $t('Change') }}</button>
              <button
                class="btn btn-danger"
                @click="deleteKey()">{{ $t('Remove') }}</button>
            </div>
          </div>
        </div>
        <div v-if="!token">
          Nenhum token gerado. <a href="javascript:void(0)" @click="generateKey()">Clique aqui</a> para gerar o token de API.
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'Password',
  components: {
  },
  data () {
    return {
      creating: true,
      loading: true,
      token: null
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    },
    me () {
      return this.$store.getters.getMe
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/apikey')
      .then(response => {
        this.token = response.data.token
        this.loading = this.creating = false
      })
      .catch(response => {
        this.token = null
        this.loading = this.creating = false
      })
    },
    generateKey () {
      this.loading = true

      this.axios
      .post('/accounts/' + this.$store.getters.getAccount._id + '/apikey')
      .then(response => {
        this.token = response.data.token
        this.loading = this.creating = false
      })
    },
    deleteKey () {
      this.loading = true

      this.axios
      .delete('/accounts/' + this.$store.getters.getAccount._id + '/apikey')
      .then(response => {
        this.token = response.data.token
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileApikey.vue